import * as React from 'react';

interface ExternalProps {
    day: string;
    disabled: boolean;
}

export class TextDropdownItem extends React.Component<ExternalProps, null> {
    constructor(props: ExternalProps) {
        super(props);
    }
    render() {
        return (
            <option value={this.props.day} disabled={this.props.disabled} > { this.props.day }</ option>
        );
    }
}

export default TextDropdownItem;
